var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Schema, MapSchema, ArraySchema, type } from "@colyseus/schema";
export class Player extends Schema {
    constructor() {
        super(...arguments);
        this.id = "";
        this.userId = ""; // empty for guests
        this.name = "";
        this.bot = false;
        this.difficulty = ""; // for bots: "easy" | "normal" | ...
        this.mmr = 1200;
        this.x = 0;
        this.y = 0;
        this.angle = 0;
        this.hp = 300;
        this.fuel = 100;
        this.power = 0;
        this.charging = false;
        this.weapon = "shell";
        this.kills = 0;
        this.deaths = 0;
        this.damageDealt = 0;
        this.shotsFired = 0;
        this.ready = false;
        this.dead = false;
        this.connected = true;
        /** True when a human dropped mid-match and a bot brain is steering
         *  their tank until they (or anyone with their userId) rejoin. */
        this.afk = false;
        this.color = 0xffffff;
        this.accentColor = 0xffd25e;
        this.bodyStyle = "heavy";
        this.turretStyle = "standard";
        this.barrelStyle = "standard";
        this.pattern = "solid";
        this.decal = "none";
        this.patternColor = 0x1a140c;
        this.facing = 1; // -1 or 1
        /** 0 = unassigned (FFA / non-team mode), 1 = team A, 2 = team B. */
        this.team = 0;
        /** Remaining rounds per weapon. Unlimited weapons don't appear here. */
        this.ammo = new MapSchema();
        /** Remaining charges per utility item. Items absent from the map are out. */
        this.items = new MapSchema();
        /** Unix ms; while > now, incoming damage is halved. 0 = no shield. */
        this.shieldExpiresAt = 0;
    }
}
__decorate([
    type("string"),
    __metadata("design:type", Object)
], Player.prototype, "id", void 0);
__decorate([
    type("string"),
    __metadata("design:type", Object)
], Player.prototype, "userId", void 0);
__decorate([
    type("string"),
    __metadata("design:type", Object)
], Player.prototype, "name", void 0);
__decorate([
    type("boolean"),
    __metadata("design:type", Object)
], Player.prototype, "bot", void 0);
__decorate([
    type("string"),
    __metadata("design:type", Object)
], Player.prototype, "difficulty", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], Player.prototype, "mmr", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], Player.prototype, "x", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], Player.prototype, "y", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], Player.prototype, "angle", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], Player.prototype, "hp", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], Player.prototype, "fuel", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], Player.prototype, "power", void 0);
__decorate([
    type("boolean"),
    __metadata("design:type", Object)
], Player.prototype, "charging", void 0);
__decorate([
    type("string"),
    __metadata("design:type", Object)
], Player.prototype, "weapon", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], Player.prototype, "kills", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], Player.prototype, "deaths", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], Player.prototype, "damageDealt", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], Player.prototype, "shotsFired", void 0);
__decorate([
    type("boolean"),
    __metadata("design:type", Object)
], Player.prototype, "ready", void 0);
__decorate([
    type("boolean"),
    __metadata("design:type", Object)
], Player.prototype, "dead", void 0);
__decorate([
    type("boolean"),
    __metadata("design:type", Object)
], Player.prototype, "connected", void 0);
__decorate([
    type("boolean"),
    __metadata("design:type", Object)
], Player.prototype, "afk", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], Player.prototype, "color", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], Player.prototype, "accentColor", void 0);
__decorate([
    type("string"),
    __metadata("design:type", Object)
], Player.prototype, "bodyStyle", void 0);
__decorate([
    type("string"),
    __metadata("design:type", Object)
], Player.prototype, "turretStyle", void 0);
__decorate([
    type("string"),
    __metadata("design:type", Object)
], Player.prototype, "barrelStyle", void 0);
__decorate([
    type("string"),
    __metadata("design:type", Object)
], Player.prototype, "pattern", void 0);
__decorate([
    type("string"),
    __metadata("design:type", Object)
], Player.prototype, "decal", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], Player.prototype, "patternColor", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], Player.prototype, "facing", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], Player.prototype, "team", void 0);
__decorate([
    type({ map: "number" }),
    __metadata("design:type", Object)
], Player.prototype, "ammo", void 0);
__decorate([
    type({ map: "number" }),
    __metadata("design:type", Object)
], Player.prototype, "items", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], Player.prototype, "shieldExpiresAt", void 0);
export class Projectile extends Schema {
    constructor() {
        super(...arguments);
        this.id = "";
        this.ownerId = "";
        this.weapon = "shell";
        this.x = 0;
        this.y = 0;
        this.vx = 0;
        this.vy = 0;
        this.tint = 0xffffff;
        this.radius = 4;
    }
}
__decorate([
    type("string"),
    __metadata("design:type", Object)
], Projectile.prototype, "id", void 0);
__decorate([
    type("string"),
    __metadata("design:type", Object)
], Projectile.prototype, "ownerId", void 0);
__decorate([
    type("string"),
    __metadata("design:type", Object)
], Projectile.prototype, "weapon", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], Projectile.prototype, "x", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], Projectile.prototype, "y", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], Projectile.prototype, "vx", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], Projectile.prototype, "vy", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], Projectile.prototype, "tint", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], Projectile.prototype, "radius", void 0);
export class FireTile extends Schema {
    constructor() {
        super(...arguments);
        this.id = "";
        this.ownerId = "";
        this.x = 0;
        this.y = 0;
        this.radius = 18;
        /** unix ms when the tile expires */
        this.expiresAt = 0;
    }
}
__decorate([
    type("string"),
    __metadata("design:type", Object)
], FireTile.prototype, "id", void 0);
__decorate([
    type("string"),
    __metadata("design:type", Object)
], FireTile.prototype, "ownerId", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], FireTile.prototype, "x", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], FireTile.prototype, "y", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], FireTile.prototype, "radius", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], FireTile.prototype, "expiresAt", void 0);
export class TerrainState extends Schema {
    constructor() {
        super(...arguments);
        this.width = 0;
        this.seed = 0;
        /** heights[x] = distance from top (smaller = taller terrain peak). */
        this.heights = new ArraySchema();
    }
}
__decorate([
    type("number"),
    __metadata("design:type", Object)
], TerrainState.prototype, "width", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], TerrainState.prototype, "seed", void 0);
__decorate([
    type(["number"]),
    __metadata("design:type", Object)
], TerrainState.prototype, "heights", void 0);
export class BattleState extends Schema {
    constructor() {
        super(...arguments);
        this.phase = "waiting";
        this.mode = "ffa";
        this.biome = "grasslands";
        this.inviteCode = ""; // only set for private rooms
        this.lobbyName = "";
        this.visibility = "public"; // "public" | "private"
        this.ranked = false;
        this.hostSessionId = "";
        this.maxPlayers = 6;
        /** True until match start: biome is a mystery that re-rolls when the match begins. */
        this.biomeRandom = false;
        /** Host set a password on the room; joiners must supply it. */
        this.hasPassword = false;
        this.players = new MapSchema();
        this.projectiles = new MapSchema();
        this.fires = new MapSchema();
        this.terrain = new TerrainState();
        this.currentTurnId = "";
        this.turnEndsAt = 0;
        this.wind = 0;
        this.roundStartsAt = 0;
        this.winnerId = "";
        /** Set when team mode ends with a clear winning team. "" for FFA, draw, or in-progress. */
        this.winnerTeam = "";
        this.teamMode = false;
        /** Number of distinct teams in team mode (2..4). 0 outside team mode. */
        this.teamCount = 0;
        /** Splash damage on allies. Defaults true to match FFA semantics; only togglable in custom team lobbies. */
        this.friendlyFire = true;
        this.matchStartedAt = 0;
        this.matchEndedAt = 0;
        this.turnNumber = 0;
        // Host-tweakable match settings applied when the match starts.
        this.turnDurationSec = 30;
        this.fuelPerTurn = 100;
        this.startingHp = 300;
        this.windMax = 25;
        /** Monotonic server clock in milliseconds — stamped each tick.
         *  Clients use it as the timeline for snapshot interpolation so they
         *  don't depend on local arrival timing or per-projectile timestamps. */
        this.serverTime = 0;
    }
}
__decorate([
    type("string"),
    __metadata("design:type", String)
], BattleState.prototype, "phase", void 0);
__decorate([
    type("string"),
    __metadata("design:type", Object)
], BattleState.prototype, "mode", void 0);
__decorate([
    type("string"),
    __metadata("design:type", Object)
], BattleState.prototype, "biome", void 0);
__decorate([
    type("string"),
    __metadata("design:type", Object)
], BattleState.prototype, "inviteCode", void 0);
__decorate([
    type("string"),
    __metadata("design:type", Object)
], BattleState.prototype, "lobbyName", void 0);
__decorate([
    type("string"),
    __metadata("design:type", Object)
], BattleState.prototype, "visibility", void 0);
__decorate([
    type("boolean"),
    __metadata("design:type", Object)
], BattleState.prototype, "ranked", void 0);
__decorate([
    type("string"),
    __metadata("design:type", Object)
], BattleState.prototype, "hostSessionId", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], BattleState.prototype, "maxPlayers", void 0);
__decorate([
    type("boolean"),
    __metadata("design:type", Object)
], BattleState.prototype, "biomeRandom", void 0);
__decorate([
    type("boolean"),
    __metadata("design:type", Object)
], BattleState.prototype, "hasPassword", void 0);
__decorate([
    type({ map: Player }),
    __metadata("design:type", Object)
], BattleState.prototype, "players", void 0);
__decorate([
    type({ map: Projectile }),
    __metadata("design:type", Object)
], BattleState.prototype, "projectiles", void 0);
__decorate([
    type({ map: FireTile }),
    __metadata("design:type", Object)
], BattleState.prototype, "fires", void 0);
__decorate([
    type(TerrainState),
    __metadata("design:type", Object)
], BattleState.prototype, "terrain", void 0);
__decorate([
    type("string"),
    __metadata("design:type", Object)
], BattleState.prototype, "currentTurnId", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], BattleState.prototype, "turnEndsAt", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], BattleState.prototype, "wind", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], BattleState.prototype, "roundStartsAt", void 0);
__decorate([
    type("string"),
    __metadata("design:type", Object)
], BattleState.prototype, "winnerId", void 0);
__decorate([
    type("string"),
    __metadata("design:type", Object)
], BattleState.prototype, "winnerTeam", void 0);
__decorate([
    type("boolean"),
    __metadata("design:type", Object)
], BattleState.prototype, "teamMode", void 0);
__decorate([
    type("uint8"),
    __metadata("design:type", Object)
], BattleState.prototype, "teamCount", void 0);
__decorate([
    type("boolean"),
    __metadata("design:type", Object)
], BattleState.prototype, "friendlyFire", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], BattleState.prototype, "matchStartedAt", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], BattleState.prototype, "matchEndedAt", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], BattleState.prototype, "turnNumber", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], BattleState.prototype, "turnDurationSec", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], BattleState.prototype, "fuelPerTurn", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], BattleState.prototype, "startingHp", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], BattleState.prototype, "windMax", void 0);
__decorate([
    type("number"),
    __metadata("design:type", Object)
], BattleState.prototype, "serverTime", void 0);
//# sourceMappingURL=schema.js.map